<script>
  import { selectedProcedures } from '../../../../../../store/common';

  const onClickRemove = id => {
    selectedProcedures.update(prev => prev.filter(item => item.id !== id));
  };
</script>

<ul class="uk-background-muted uk-padding-small" data-uk-accordion>
  <li>
    <a class="uk-accordion-title uk-text-small uk-text-secondary" href="#">
      You have <strong>{$selectedProcedures.length}</strong> items in your bucket
      list.
    </a>

    <div class="uk-accordion-content uk-text-small">
      <ul class="uk-list">
        {#each $selectedProcedures as item}
          <li class="uk-flex uk-flex-between">
            <span class="text-ellipsis uk-margin-small-right">
              {item.name} / {item.body_part_name} / {item.body_area_name}
            </span>

            <a
              class="uk-link-reset"
              href="#"
              on:click={() => onClickRemove(item.id)}
            >
              <span data-uk-icon="icon: close; ratio: 0.875" />
            </a>
          </li>
        {/each}
      </ul>
    </div>
  </li>
</ul>
